<template>
  <div>
    <el-dialog
      v-loading="loading"
      :title="`修改課堂`"
      :visible.sync="dialogEditVisibleProp"
      width="80%"
      :append-to-body="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @open="open()"
    >
      <el-form ref="editForm" :model="editForm" :rules="rules" label-width="140px" class="demo-ruleForm">
        <div class="createPost-main-container">
          <el-row>
            <el-col :span="12">
              <el-form-item label="課堂編號:" style="margin-bottom: 30px;" prop="lessonNumber">
                {{ editForm.number }}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="老師:" style="margin-bottom: 30px;" prop="teacher">
                <multiselect v-model="editForm.teacher" :options="teacherOptions" :custom-label="nameWithLang" placeholder="Select..." label="name" track-by="name" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="課程名稱:" style="margin-bottom: 30px;" prop="course">
                <multiselect v-model="editForm.course" :options="courseOptions" :custom-label="nameWithLang" placeholder="Select..." label="name" track-by="name" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="學生:" style="margin-bottom: 30px;" prop="students">
                <multiselect v-if="editForm.type==='tutor'" v-model="editForm.students" :options="studentOptions" :custom-label="nameWithLang" placeholder="Select..." label="name" track-by="name" />
                <multiselect v-if="editForm.type==='group'" v-model="editForm.students" :options="studentOptions" :close-on-select="false" :custom-label="nameWithLang" placeholder="Select..." :multiple="true" :max="editForm.groupMaxEnrollNum" label="name" track-by="name" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="課程類型:" style="margin-bottom: 30px;" prop="typeName">
                <span>{{ editForm.typeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="課堂定價:" style="margin-bottom: 30px;" prop="price">
                <span>{{ editForm.price }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.course.type == 'group'">
              <el-form-item label="團體課最大人數:" style="margin-bottom: 30px;" prop="groupMaxEnrollNum">
                <span>{{ editForm.groupMaxEnrollNum }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button type="danger" @click="onSaveEvent($event)">儲存</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import Multiselect from 'vue-multiselect'
import EventResource from '@/api/event'
const eventResource = new EventResource()

const defaultEditForm = {
  id: 0,
  number: '',
  type: 'tutor',
  typeName: '家教課',
  price: 0,
  groupMaxEnrollNum: 0,
  teacher: [],
  students: [],
  course: []
}
export default {
  name: 'EditDialog',
  components: { Multiselect },
  props: {
    dialogEditVisibleProp: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    const validateTeacher = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('請選擇老師'))
      } else {
        callback()
      }
    }
    const validateCourse = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('請選擇課程'))
      } else {
        callback()
      }
    }
    const validateStudents = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('請至少選擇一個學生'))
      } else {
        callback()
      }
    }
    return {
      editForm: Object.assign({}, defaultEditForm),
      loading: false,
      rules: {
        teacher: [{ validator: validateTeacher, trigger: 'blur' }],
        course: [{ validator: validateCourse, trigger: 'blur' }],
        students: [{ validator: validateStudents, trigger: 'blur' }]
      },
      teacherOptions: [],
      studentOptions: [],
      courseOptions: []
    }
  },
  watch: {
    'editForm.course': function() {
      if (this.editForm.course) {
        this.editForm.type = this.editForm.course.type
        this.editForm.price = this.editForm.course.price
        if (this.editForm.course.type === 'tutor') {
          this.editForm.typeName = '家教課'
        } else {
          this.editForm.typeName = '團體課'
        }
        this.editForm.groupMaxEnrollNum = this.editForm.course.groupMaxEnrollNum
      }
    }
  },
  methods: {
    async open() {
      this.loading = true
      await this.getLessonInputOptions()
      this.editForm.id = this.$parent.currentEditItem.id
      this.editForm.number = this.$parent.currentEditItem.number
      this.editForm.teacher = {
        number: this.$parent.currentEditItem.teacherNumber,
        name: this.$parent.currentEditItem.teacherName
      }
      this.editForm.course = {
        number: this.$parent.currentEditItem.courseNumber,
        name: this.$parent.currentEditItem.courseTitle,
        type: this.$parent.currentEditItem.courseType,
        price: this.$parent.currentEditItem.coursePrice,
        groupMaxEnrollNum: this.$parent.currentEditItem.courseGroupMaxEnrollNum
      }
      const students = []
      this.$parent.currentEditItem.students.forEach(function(item) {
        students.push({ number: item.number, name: item.name })
      })
      this.editForm.students = students
      this.loading = false
    },
    async getLessonInputOptions() {
      const { teacher, course, student } = await eventResource.getLessonInputOptions()
      // console.log(teacher)
      const teacherOptions = []
      teacher.forEach(function(item) {
        teacherOptions.push({ number: item.number, name: item.name })
      })
      this.teacherOptions = teacherOptions

      const courseOptions = []
      course.forEach(function(item) {
        courseOptions.push({ number: item.number, name: item.title, type: item.type, price: item.price, groupMaxEnrollNum: item.group_max_enroll_num })
      })
      this.courseOptions = courseOptions

      const studentOptions = []
      student.forEach(function(item) {
        studentOptions.push({ number: item.number, name: item.name })
      })
      this.studentOptions = studentOptions
    },
    onSaveEvent(event) {
      this.sendData()
    },
    async sendData() {
      console.log(this.editForm)
      const { data } = await eventResource.updateLesson(this.editForm)
      const actionTitle = '編輯課堂 '
      if (data.code === 0) {
        this.$parent.dialogEditVisible = false
        this.reloadParentData()
        this.$parent.messageNotify(
          actionTitle + this.$parent.errorCodeMessage[data.code]['title'],
          this.$parent.errorCodeMessage[data.code]['message'],
          this.$parent.errorCodeMessage[data.code]['type']
        )
      } else {
        this.$parent.messageNotify(
          '編輯課堂失敗',
          data.errors,
          'error'
        )
        return false
      }
    },
    handleClose(done) {
      this.resetData()
      this.$parent.dialogEditVisible = false
    },
    reloadParentData() {
      this.$parent.getList()
      this.resetData()
    },
    resetData() {
      this.editForm = {
        id: 0,
        number: '',
        type: 'tutor',
        typeName: '家教課',
        price: 0,
        groupMaxEnrollNum: 0,
        teacher: [],
        students: [],
        course: []
      }
    },
    nameWithLang({ name, number }) {
      return `${name} — [${number}]`
    },
    idWithLang({ name, id }) {
      return `${name}`
    }
  }
}
</script>
